interface ErrorMonitor {
  captureException(exception: unknown): string;
}

function errorMonitorFallbackApi(): ErrorMonitor {
  return {
    captureException: String,
  };
}

export function getErrorMonitorCompat(essentials: {
  errorMonitor?: ErrorMonitor | null;
}): ErrorMonitor {
  try {
    return essentials.errorMonitor ?? errorMonitorFallbackApi();
  } catch (e) {
    console.error(e);
    return errorMonitorFallbackApi();
  }
}
